import React, { FC, useEffect, useState } from 'react';
import { Button, Card } from 'antd';
import { Student } from '../../../models/student.model';
import { Col, Row, Table } from 'react-bootstrap';
import { mutationNotification, useGet, usePost } from '../../../hooks/useApi';
import { AdditionalGuardian } from '../../../models/additional-guardian.model';

interface StudentInformationProps {
  student: Partial<Student>;
}

const StudentAdditionalGuardians: FC<StudentInformationProps> = ({
  student,
}) => {
  const [newStudentAdditionalGuardians, setNewStudentAdditionalGuardians] =
    useState<number[]>([]);

  const additionalGuardians = useGet<AdditionalGuardian[]>(
    '/v1/auth/dashboard/additional-guardians'
  );
  const studentAdditionalGuardians = useGet<AdditionalGuardian[]>(
    '/v1/auth/dashboard/additional-guardians/student/' + student.id
  );

  const post = usePost<any, any>(
    '/v1/auth/dashboard/additional-guardians/student/' + student.id
  );

  useEffect(() => {
    if (studentAdditionalGuardians.isSuccess) {
      setNewStudentAdditionalGuardians(
        studentAdditionalGuardians.data.map((x) => x.id)
      );
    }
  }, [studentAdditionalGuardians.data]);

  useEffect(() => {
    mutationNotification(post, {
      success: {
        title: 'Success',
        description: 'Student information has been updated successfully.',
      },
      error: {
        title: 'Update Failed',
      },
    });
  }, [post.isSuccess, post.isError]);

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const id = parseInt(e.target.value);
    setNewStudentAdditionalGuardians((prevState) =>
      prevState.includes(id)
        ? prevState.filter((item) => item !== id)
        : [...prevState, id]
    );
  };

  const onFinish = (ev: any) => {
    ev.preventDefault();
    post.mutate(newStudentAdditionalGuardians);
  };

  const Box = () => (
    <div
      style={{
        backgroundColor: '#eadef3',
        padding: '1rem',
        border: '1px solid rgba(10,10,10,.25)',
        fontSize: '16px',
      }}
    >
      <p className={'pb-3'}>
        Changes will only be saved if you click the save/update button after you
        have made your selections.
      </p>
      <p className={'pb-3'}>
        If there are no Additional Guardians listed, you will need to add them
        before you can attach them to a student. That can be done{' '}
        <a
          href={'/additional-guardian/new'}
          target={'_blank'}
          style={{ color: '#703895' }}
          rel="noreferrer"
        >
          here
        </a>
        .
      </p>
    </div>
  );
  return (
    <Row>
      <Col md={6}>
        <Card
          id={'Assign-Additional-Guardians'}
          title="Assign Additional Guardians"
          bordered={false}
          loading={
            additionalGuardians.isLoading ||
            studentAdditionalGuardians.isLoading ||
            post.isLoading
          }
        >
          <p className={'pb-3'}>
            Check all Additional Guardians that should be assigned to this
            student.
          </p>

          <Table bordered={true} striped={true}>
            <tbody>
              {additionalGuardians.data?.map((guardian) => (
                <tr key={guardian.id}>
                  <td style={{ width: '20px' }}>
                    <input
                      id={`additionalGuardian-${guardian.id}`}
                      type="checkbox"
                      value={guardian.id}
                      checked={newStudentAdditionalGuardians.includes(
                        guardian.id
                      )}
                      onChange={onChange}
                    />
                  </td>
                  <td>
                    {guardian.firstName} {guardian.lastName}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

          <Button
            id="saveAdditionalGuardians"
            block
            size="large"
            type="primary"
            htmlType="button"
            onClick={onFinish}
          >
            Save/Update
          </Button>
        </Card>
      </Col>
      <Col md={6}>
        <Box />
      </Col>
    </Row>
  );
};

export default StudentAdditionalGuardians;
